import {
  type AudienceConfig,
  type ContractConfig,
  type BasicConfig,
  type NetworkType,
} from "../models/app-config";
import { filterActiveAudienceSubscriptionAssets } from "./audience-subs";
import { normalizeDisabledChatAddresses } from "./secureChat";
const formatNetworks = (networks: NetworkType[]): NetworkType[] => {
  return (networks ?? []).map((network: NetworkType) => ({
    ...network,
    chain_id: Number(network.chain_id),
  }));
};

const getBasicConfig = (chatConfig: any): BasicConfig => {
  const maxMembersGroup = chatConfig?.max_members_group;
  const maxMembersParty = chatConfig?.max_members_party;
  const maxMultiTransfer = chatConfig?.max_multi_transfer;
  const maxPinsNFT = chatConfig?.max_pins;
  const rankingLevels = chatConfig?.ranking_levels;
  const pinnedChainIds = chatConfig?.pinned_chain_ids;
  const payToOpenAssets = chatConfig?.pay_to_open_assets;
  const supportNetworks = formatNetworks(chatConfig?.pay_to_open_networks);
  const snsDomain = chatConfig?.sns_domain;
  const partyInvitationURL = `${snsDomain}/party/invite`;
  const maxPinnedRooms = chatConfig?.max_pinned_rooms;
  const audienceSubscriptionNetworks =
    formatNetworks(chatConfig?.audience_subscription_networks) ?? [];

  // Filter only active assets from audience_subscription_assets
  const audienceSubscriptionToken = filterActiveAudienceSubscriptionAssets(
    chatConfig?.audience_subscription_assets
  );

  const audienceSubscriptionReferralFee =
    chatConfig?.audience_subscription_referral_fee ?? 0;
  const audienceSubscriptionDurationPlans =
    chatConfig?.audience_subscription_plans ?? [];
  const enableAudienceSubscription =
    chatConfig?.is_audience_subscription_enabled ?? false;
  const maintenance = chatConfig?.maintenance ?? null;

  const disabledChatAddresses = normalizeDisabledChatAddresses(
    chatConfig?.disabled_chat_addresses
  );

  return {
    disabledChatAddresses,
    maxMembersGroup,
    maxMembersParty,
    maxMultiTransfer,
    maxPinsNFT,
    rankingLevels,
    pinnedChainIds,
    payToOpenAssets,
    supportNetworks,
    snsDomain,
    partyInvitationURL,
    maxPinnedRooms,
    audienceSubscriptionNetworks,
    audienceSubscriptionToken,
    audienceSubscriptionReferralFee,
    audienceSubscriptionDurationPlans,
    enableAudienceSubscription,
    maintenance,
  };
};

const getAudienceConfig = (rawAudience: any): AudienceConfig => {
  const audience = {
    sendTextMessage: rawAudience?.send_text_message ?? false,
    sendAttachmentMessage: rawAudience?.send_attachment_message ?? false,
    sendPayment: rawAudience?.send_payment ?? false,
    sendPaymentRequest: rawAudience?.send_payment_request ?? false,
    sendPayToOpen: rawAudience?.send_pay_to_open ?? false,
    reactMessage: rawAudience?.react_message ?? false,
    unSendMessage: rawAudience?.unsend_message ?? false,
    deleteMessage: rawAudience?.delete_message ?? false,
  };
  return audience;
};

const getContractConfig = (rawContracts: any): ContractConfig => {
  const {
    followed_ntt: followedNTTContract,
    following_ntt: followingNTTContract,
    multiple_transfer: multipleTransferContract,
    nft_issue: nftIssueContract,
    pay_to_open: payToOpenContract,
    social: socialContract,
    audience_subscription: audienceSubscription,
  } = rawContracts ?? {};

  return {
    followedNTTContract: followedNTTContract ?? {},
    followingNTTContract: followingNTTContract ?? {},
    multipleTransferContract: multipleTransferContract ?? {},
    nftIssueContract: nftIssueContract ?? {},
    payToOpenContract: payToOpenContract ?? {},
    socialContract: socialContract ?? {},
    audienceSubscription: audienceSubscription ?? {},
  };
};

export { getBasicConfig, getAudienceConfig, getContractConfig };
